import { optionsToStrategy } from '@/common/utils/optionsToStrategy';

export const options = [
  { label: 'Boleto', value: 'bank_slip' },
  { label: 'Depósito', value: 'bank_deposit' },
];

export const strategy = optionsToStrategy(options);
